'use client';
import { useTransTournament } from '@/@shared/hooks/useTranslations';
import styles from '@/app/[locale]/page.module.scss';
import LayoutColorOption from '@/legacy/components/apps/Option';
import TournamentBanner from '@/legacy/components/new/TournamentBanner';
import TournamentChampion from '@/legacy/components/new/TournamentChampion';
import TournamentLive from '@/legacy/components/new/TournamentLive';
import TournamentMain from '@/legacy/components/new/TournamentMain';
import TournamentOpen from '@/legacy/components/new/TournamentOpen';

const Page = () => {
	const t = useTransTournament('temp.home');
	return (
		<LayoutColorOption
			background="dark"
			ChatVisible={true}
			headerBackground={'black'}
			headerTextColor="white"
			logoVisible={true}
			menuVisible={true}
		>
			<main className={styles.main}>
				<TournamentMain />
				<TournamentChampion />

				<TournamentOpen />

				<TournamentBanner />

				<TournamentLive description={t('watchMatch')} status="LIVE" title={t('liveTournament')} />
				<TournamentLive description={t('whoWon')} status="DONE" title={t('doneTournament')} />
			</main>
		</LayoutColorOption>
	);
};

export default Page;
